import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';
import { LoginByLinkResponse } from '../../domain/models/login-by-link-response.model';
import { ValidateCodeModel } from '../../domain/models/validate-code-model';

export class ValidateCode implements ServiceCommand<ValidateCode.Response> {
  constructor(
    private readonly httpClient: HttpClient<ValidateCode.Response>,
    private readonly url: string
  ) {}

  async execute(
    params: ValidateCode.Params
  ): Promise<ServiceCommand.Response<ValidateCode.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.POST,
      url: this.url,
      body: params
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;

    return success(response);
  }
}

export namespace ValidateCode {
  export type Params = ValidateCodeModel;

  export type Response = LoginByLinkResponse;
}
